import { updateListingScore } from '@/utils/product/score';
import { getOversetValue } from '@/utils/product/checkAttribute';
import { getTitleError } from '@/utils/validations/title';
import { clearErrors } from '@/utils/errors';
import { escapeRegex } from '@/utils/string';

import { FIND, OPERATIONS, REPLACE } from '@/constants/bulkEdit';
import { OVERSET, VALUE } from '@/constants/product';
import { ATTRIBUTE } from '@/constants/attributes';
import { SHOPIFY } from '@/constants/channels';
import { FORM } from '@/constants/forms';

export default function title({ actions, operation, product, shop, userFeatures }) {
  const channel = product.get('channel');

  function setValueToProduct(value) {
    let result = product.setIn([FORM.TITLE, VALUE], value);

    if (operation.hasIn(['ai', 'original'])) {
      result = result.setIn([FORM.TITLE, 'ai'], operation.get('ai'));
    }

    if (result.hasIn(['score', ATTRIBUTE.TITLE])) {
      result = updateListingScore({ product: result, shop, userFeatures });
    }

    switch (channel) {
      case SHOPIFY: {
        if (product.getIn([FORM.SEO, ATTRIBUTE.PAGE_TITLE, OVERSET])) {
          result = result.setIn([FORM.SEO, ATTRIBUTE.PAGE_TITLE, VALUE],
            getOversetValue({ attribute: ATTRIBUTE.PAGE_TITLE, product: result })
          );
        }

        break;
      }

      default: {
        break;
      }
    }

    return result;
  }

  function validateAndApply(value) {
    return {
      actions,
      product: getTitleError({ channel, value })
        ? product
        : clearErrors({ errors: [ATTRIBUTE.TITLE], product: setValueToProduct(value) }),
    };
  }

  switch (operation.get('type')) {
    case OPERATIONS[channel].TITLE.ADD_AFTER: {
      const value = `${product.getIn([FORM.TITLE, VALUE])}${operation.get(VALUE)}`;
      return validateAndApply(value);
    }

    case OPERATIONS[channel].TITLE.ADD_BEFORE: {
      const value = `${operation.get(VALUE)}${product.getIn([FORM.TITLE, VALUE])}`;
      return validateAndApply(value);
    }

    case OPERATIONS[channel].TITLE.DELETE: {
      const pattern = new RegExp(escapeRegex(operation.get(VALUE)), 'ig');
      const value = product.getIn([FORM.TITLE, VALUE]).replace(pattern, '');
      return validateAndApply(value);
    }

    case OPERATIONS[channel].TITLE.FIND_AND_REPLACE: {
      const pattern = new RegExp(escapeRegex(operation.getIn([VALUE, FIND])), 'ig');
      const value = product
        .getIn([FORM.TITLE, VALUE])
        .replace(pattern, operation.getIn([VALUE, REPLACE]));

      return validateAndApply(value);
    }

    case OPERATIONS[channel].TITLE.SET: {
      const value = operation.get(VALUE);
      return validateAndApply(value);
    }

    default: {
      return { actions, product };
    }
  }
}
